import {useState} from 'react'
import OnboardingPipelines from './OnboardingPipelines'
import Prospects from './Prospects'


import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'

import useCurrentUser from '../../hooks/useCurrentUser'

const CopyEmbed = () => {
  const [isCopied, setIsCopied] = useState(false);

  const user = useCurrentUser()

  const embed = `<iframe width="500" height="700" src="${window.location.origin}/intake-embed/?owner=${user.user_id_number}" style="box-shadow:none !important; border:none; outline: none; margin:0;"/>`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(embed);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000); // Reset the copied status after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
      <Button variant={isCopied?"outline-success":"outline-secondary"} onClick={handleCopy}>
        {isCopied ? 'Copied!' : 'Copy Embed Form'}
      </Button>
  );
}

function Growth () {
	const params = new URLSearchParams(window.location.search)
	const [tab,setTab] = useState(params.get('tab') || 'prospects')
	return (
		<div className="pt-4 px-2 px-md-3">
			<strong>Grow your fitness business</strong>
			<hr/>
			<div className="mb-2">
				<Button 
					className="mr-2"
					variant={tab==='prospects'?'primary':'outline-primary'}
					onClick={setTab.bind(null,'prospects')}
				>
					Prospect List
				</Button>
				<OverlayTrigger overlay={
					<Tooltip>
						Automated emails, follow ups and more
					</Tooltip>
				}>
					<Button 
						className="mr-2"
						variant={tab==='pipelines'?'primary':'outline-primary'}
						onClick={setTab.bind(null,'pipelines')}
					>
						Automations
					</Button>
				</OverlayTrigger>
				<CopyEmbed/>
			</div>
			{tab==='prospects'&&
				<Prospects/>
			}
			{tab==='pipelines'&&
				<OnboardingPipelines/>
			}
		</div>
	)
}

export default Growth